export const RECEIVED_SOCKET_DATA = "RECEIVED_SOCKET_DATA"
export const SET_TOPIC = "SET_TOPIC"